import React from 'react'
import { useHistory } from 'react-router'
import { IconButton, Tooltip } from '@material-ui/core'
import { ExitToAppRounded } from '@material-ui/icons'
import { Strings } from '../../assets/res/en'
export default function NavProfile() {
    const { replace } = useHistory()
    return (
        <Tooltip title={Strings.LOGOUT_TITLE}>
            <IconButton onClick={() => { replace("/login") }} edge="end" color="secondary">
                <ExitToAppRounded />
            </IconButton>
        </Tooltip>
    )
}
